import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyDatePickerModule } from 'mydatepicker';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { EmployeeReportRoutingModule } from './employee-report-routing.module';
import { EmployeeReportComponent } from './employee-report.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { dropdownModule } from 'src/app/dropdown/dropdown.module';
@NgModule({
  declarations: [EmployeeReportComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    MyDatePickerModule,
    GridModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    DropDownListAllModule,
    EmployeeReportRoutingModule,
    dropdownModule
  ],
})
export class EmployeeReportModule { }